import type { EventSummary, Prospect } from '../types/crm'

export const demoEvent: EventSummary = {
  id: 'event-nrf-2026',
  name: 'NRF 2026',
  slug: 'nrf-2026',
  city: 'New York',
  country: 'États-Unis',
  venue: 'Jacob K. Javits Convention Center',
  startDate: '2026-01-11',
  endDate: '2026-01-13',
  status: 'TERMINE',
  notes: 'Données de démonstration — remplacer par les lignes du fichier source.',
  prospectCount: 84,
  priorityACount: 12,
  contactsToIdentifyCount: 56,
  metCount: 5,
}

const companies: Array<[string, number, string]> = [
  ['Carrefour', 6000, 'Grande distribution alimentaire'], ['Auchan', 2100, 'Grande distribution alimentaire'],
  ['E.Leclerc', 734, 'Grande distribution alimentaire'], ['Intermarché', 1887, 'Grande distribution alimentaire'],
  ['Netto', 311, 'Discount alimentaire'], ['Decathlon', 330, 'Sport'], ['Monoprix', 700, 'Commerce de proximité'],
  ['Franprix', 1100, 'Commerce de proximité'], ['Casino', 7800, 'Grande distribution alimentaire'],
  ['Lidl France', 1600, 'Discount alimentaire'], ['Aldi France', 1300, 'Discount alimentaire'],
  ['Système U', 1726, 'Grande distribution alimentaire'], ['Picard', 1150, 'Surgelés'],
  ['Fnac Darty', 987, 'Électronique et culture'], ['Boulanger', 220, 'Électronique'],
  ['Leroy Merlin', 145, 'Bricolage'], ['Castorama', 95, 'Bricolage'], ['Brico Dépôt', 123, 'Bricolage'],
  ['Mr.Bricolage', 1000, 'Bricolage'], ['BUT', 330, 'Ameublement'], ['Conforama', 175, 'Ameublement'],
  ['IKEA France', 36, 'Ameublement'], ['Sephora', 320, 'Beauté'], ['Marionnaud', 500, 'Beauté'],
  ['Nocibé', 610, 'Beauté'], ['Yves Rocher', 680, 'Beauté'], ['Kiabi', 580, 'Mode'], ['Jules', 460, 'Mode'],
  ['Celio', 500, 'Mode'], ['Etam', 850, 'Mode'], ['Galeries Lafayette', 65, 'Grand magasin'],
  ['Printemps', 20, 'Grand magasin'], ['La Redoute', 1, 'E-commerce'], ['Cdiscount', 1, 'E-commerce'],
  ['Amazon France', 1, 'E-commerce'], ['Veepee', 1, 'E-commerce'], ['Action France', 800, 'Bazar discount'],
  ['Normal', 150, 'Bazar discount'], ['GiFi', 600, 'Équipement de la maison'],
  ["La Foir'Fouille", 270, 'Équipement de la maison'], ['Cultura', 110, 'Culture et loisirs'],
  ['Intersport', 980, 'Sport'], ['Sport 2000', 680, 'Sport'], ['Go Sport', 80, 'Sport'],
  ['Jardiland', 200, 'Jardinerie'], ['Truffaut', 65, 'Jardinerie'], ['Botanic', 75, 'Jardinerie'],
  ['Grand Frais', 310, 'Distribution alimentaire'], ['Biocoop', 740, 'Distribution bio'],
  ['Naturalia', 245, 'Distribution bio'], ['Coopérative U', 1700, 'Grande distribution alimentaire'],
  ['METRO France', 99, 'Commerce de gros'], ['Promocash', 150, 'Commerce de gros'],
  ['Transgourmet', 45, 'Commerce de gros'], ['Pomona', 190, 'Distribution professionnelle'],
  ['Burger King France', 520, 'Restauration'], ["McDonald's France", 1560, 'Restauration'],
  ['KFC France', 370, 'Restauration'], ['Quick', 140, 'Restauration'], ['Accor', 1800, 'Hôtellerie'],
  ['Louvre Hotels Group', 950, 'Hôtellerie'], ['Lagardère Travel Retail', 5000, 'Travel retail'],
  ['Relay', 800, 'Travel retail'], ['TotalEnergies', 3500, 'Stations-service'], ['Shell France', 90, 'Stations-service'],
  ['Norauto', 410, 'Automobile'], ['Feu Vert', 350, 'Automobile'], ['Midas', 367, 'Automobile'],
  ['Point S', 660, 'Automobile'], ['Optical Center', 750, 'Optique'], ['Alain Afflelou', 800, 'Optique'],
  ['Krys Group', 1100, 'Optique'], ['GrandVision France', 900, 'Optique'], ['Pharmabest', 118, 'Pharmacie'],
  ['Lafayette Conseil', 170, 'Pharmacie'], ['Bureau Vallée', 400, 'Fournitures de bureau'],
  ['Top Office', 35, 'Fournitures de bureau'], ['King Jouet', 330, 'Jouets'], ['JouéClub', 300, 'Jouets'],
  ['Orchestra', 300, 'Enfant et puériculture'], ['Maxi Zoo', 350, 'Animalerie'], ['Animalis', 80, 'Animalerie'],
  ['Stokomani', 150, 'Déstockage'], ['NOZ', 330, 'Déstockage'],
]

export const demoProspects: Prospect[] = companies.map(([name, storeCount, sector], index) => {
  const n = index + 1
  const met = [3, 7, 16, 28, 48].includes(n)
  const appointment = [1, 2, 6, 14, 23, 31, 52, 62].includes(n)
  const priority = n <= 12 ? 'A' : n <= 42 ? 'B' : 'C'
  const knownContact = n % 3 === 0
  return {
    id: `cmp-${String(n).padStart(3, '0')}`,
    name, storeCount, sector, country: 'France', eventId: demoEvent.id, priority,
    representativeCount: [3, 5, 2, 1, 8][n % 5], seniorProfileCount: n % 4 === 0 ? 2 : 1,
    profilesPresent: n % 2 === 0 ? 'Direction innovation / Store Technology' : 'Direction achats / Opérations',
    eslOpportunity: n % 4 === 0 ? 'NON' : 'OUI', enchantOpportunity: n % 3 === 0 ? 'OUI' : 'NON',
    elabelOpportunity: [0, 1].includes(n % 5) ? 'OUI' : 'NON',
    currentEsl: ['Vusion', 'Pricer', 'Inconnu', 'Aucun', 'Vusion / Pricer'][n % 5],
    contactIdentifiedSummary: knownContact ? 'Contact direction identifié dans la source' : null,
    contactToIdentify: knownContact ? null : 'Responsable Store Technology / Achats',
    commercialAngle: 'Qualifier le parc installé et les projets de digitalisation magasin',
    eventAction: n <= 12 ? 'Contacter avant le salon et proposer un rendez-vous' : 'Identifier le bon interlocuteur pendant le salon',
    preparationProgress: n <= 12 ? 75 : n <= 42 ? 50 : 25,
    appointmentPlanned: appointment, met,
    followUpStatus: met ? 'À relancer' : appointment ? 'RDV confirmé' : 'À préparer',
    nextAction: n % 4 === 0 ? 'Envoyer une présentation DIGI' : 'Qualifier le contact décisionnaire',
    nextActionDate: n % 6 === 0 ? '2026-09-18' : null,
    favorite: n <= 4, contactCount: n === 1 ? 1 : knownContact ? 1 : 0,
    contacts: n === 1 ? [{ id: 'contact-carrefour-1', firstName: 'Emmanuel', lastName: 'Grenier', jobTitle: 'Owner Store Technology', email: 'emmanuel.grenier@example.invalid', phone: '+33100000000', linkedinUrl: 'https://www.linkedin.com/', isPrimary: true }] : [],
    activities: n === 1 ? [
      { id: 'activity-carrefour-1', type: 'NOTE', title: 'Préparation NRF', description: 'Qualifier les limites du programme ESL existant.', createdAt: '2026-09-11T09:00:00Z' },
      { id: 'activity-carrefour-2', type: 'CONTACT', title: 'Contact identifié', description: 'Emmanuel Grenier ajouté.', createdAt: '2026-09-10T14:30:00Z' },
    ] : [],
  }
})
